import { getWorkSpaces } from "Areas/Sidebar/WorkSpaces";
import { actionCreators as editorActionCreators } from "Areas/WorkSpaces/workSpaceEditorPanel";
import { Permissions, security } from "Common/permissions";
import { connect } from "react-redux";
import Welcome from "./welcome";
const canEdit = security.isAllowed([Permissions.WorkSpacesEdit]);
const mapStateToProps = (state) => {
    var _a;
    return ({
        workSpacesCount: (_a = getWorkSpaces(state)) === null || _a === void 0 ? void 0 : _a.length,
        canEdit
    });
};
const mapDispatchToProps = (dispatch) => ({
    onOpenWorkSpaceCreatorPanel: () => dispatch(editorActionCreators.setNewWorkSpace())
});
export default connect(mapStateToProps, mapDispatchToProps)(Welcome);
